import { render } from "./ff-textarea.vue?vue&type=template&id=4add003a&scoped=true"
import script from "./ff-textarea.vue?vue&type=script&lang=js"
export * from "./ff-textarea.vue?vue&type=script&lang=js"

import "./ff-textarea.vue?vue&type=style&index=0&id=4add003a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4add003a"

export default script